import styled from "styled-components";
import { media } from "../../utils/media";

export const HeroContainer = styled.div`
  background: ${({ theme }) => theme.card_light};
  display: flex;
  justify-content: center;
  position: relative;
  padding: 80px 30px;
  ${media.down('lg')} {
    padding: 66px 16px;
  }
  ${media.down('sm')} {
    padding: 32px 16px;
  }
  z-index: 1;

  clip-path: polygon(0 0, 100% 0, 100% 100%, 70% 95%, 0 100%);
`;

export const HeroBg = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 1360px;
  overflow: hidden;
  padding: 0 30px;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);

  @media (max-width: 960px) {
    justify-content: center;
    padding: 0 0px;
  }
`;

export const HeroInnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1100px;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
export const HeroLeftContainer = styled.div`
  width: 100%;
  order: 1;
  @media (max-width: 960px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 640px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const HeroRightContainer = styled.div`
  width: 100%;
  display: flex;
  order: 2;
  justify-content: end;
  gap: 12px;
  @media (max-width: 960px) {
    order: 1;
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;
  }

  @media (max-width: 640px) {
    margin-bottom: 30px;
  }
`;

export const Img = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 400px;
  max-height: 400px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.primary};

  @media (max-width: 768px) {
    max-width: 400px;
    max-height: 400px;
  }

  @media (max-width: 640px) {
    max-width: 280px;
    max-height: 280px;
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  font-size: 50px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 68px;
  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 40px;
    line-height: 48px;
    margin-bottom: 8px;
  }
`;

export const TextLoop = styled.div`
  font-weight: 600;
  font-size: 32px;
  display: flex;
  gap: 12px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 68px;
  @media (max-width: 960px) {
    text-align: center;
  }
  @media (max-width: 640px) {
    font-size: 22px;
    line-height: 48px;
    margin-bottom: 16px;
  }
`;

export const Span = styled.span`
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
`;

export const SubTitle = styled.div`
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 42px;
  color: ${({ theme }) => theme.text_primary + 95};

  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 16px;
    line-height: 32px;
  }
`;

export const ResumeButton = styled.a`
    -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;
    text-decoration: none;
    width: 95%;
    max-width: 300px;
    text-align: center;
    padding: 16px 0;
    color: ${({ theme }) => theme.white || '#FFFFFF'};
    border-radius: 20px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 600;
    transition: all 0.2s ease-in-out !important;
    background: hsla(271, 100%, 50%, 1);
    background: linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
    background: -moz-linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
    background: -webkit-linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
    box-shadow: ${({ theme }) =>
      theme.card === '#171721'
        ? '20px 20px 60px #1F2634, -20px -20px 60px #1F2634'
        : '0 14px 36px rgba(0,0,0,0.18)'};
    &:hover {
        transform: scale(1.05);
    transition: all 0.4s ease-in-out;
    box-shadow: ${({ theme }) =>
      theme.card === '#171721'
        ? '20px 20px 60px #1F2634, -20px -20px 60px #1F2634'
        : '0 18px 44px rgba(0,0,0,0.22)'};
    filter: brightness(1.05);
    }    
    
    
    @media (max-width: 640px) {
        padding: 12px 0;
        font-size: 18px;
    } 

`;

export const SocialMediaIcons = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 24px;
  @media (max-width: 960px) {
    justify-content: center;
  }
`;

export const CTARow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  max-width: 520px;
  margin-top: 8px;

  @media (max-width: 960px) {
    justify-content: center;
  }
`;

export const SecondaryButton = styled.a`
  appearance: button;
  text-decoration: none;
  text-align: center;
  padding: 14px 22px;
  min-width: 140px;
  color: ${({ theme }) => theme.primary};
  border: 1.8px solid ${({ theme }) => theme.primary};
  border-radius: 20px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  background: transparent;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${({ theme }) => theme.primary + '18'};
    transform: translateY(-2px);
  }

  @media (max-width: 640px) {
    font-size: 16px;
    padding: 12px 18px;
  }
`;

export const ReadMoreButton = styled.button`
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.primary};
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-top: 8px;
  text-decoration: underline;
  text-underline-offset: 3px;

  &:hover {
    opacity: 0.85;
  }
`;

export const ResumeMenu = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  width: min(320px, 95vw);
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.primary + '55'};
  border-radius: 14px;
  padding: 10px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.2);
  z-index: 20;
  display: grid;
  gap: 8px;
`;

export const ResumeMenuLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.text_primary};
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.primary + '35'};
  background: ${({ theme }) => theme.primary + '12'};
  font-weight: 600;
  text-align: center;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.primary + '28'};
    color: ${({ theme }) => theme.primary};
  }
`;

export const ScrollIndicator = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-top: 32px;
  color: ${({ theme }) => theme.text_secondary};
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  animation: bounce 2s ease-in-out infinite;

  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(6px); }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const SocialMoreWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const SocialMoreMenu = styled(ResumeMenu)`
  left: auto;
  right: 0;
  transform: none;
  min-width: 160px;
`;

export const SocialMediaIcon = styled.a`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.text_secondary + 20};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: ${({ theme }) => theme.text_primary};
  font-size: 20px;
  
  &:hover {
    transform: translateY(-4px);
    background-color: ${({ theme }) => theme.primary};
    box-shadow: 0 6px 20px rgba(133, 76, 230, 0.4);
  }
  
  @media (max-width: 640px) {
    width: 36px;
    height: 36px;
    font-size: 18px;
  }
`;